import { datadogAdapter } from "./adapters/datadog";
import { guard } from "./guard";
import type { TelemetryLogLevel } from "./types";

const write = (level: TelemetryLogLevel) => (message: string) =>
  guard(() => datadogAdapter.log(level, message));

/**
 * Log lines to the telemetry vendor: Datadog Logs on native, the console on
 * web (which browser RUM captures). `Common/Utils/logger` is the only caller,
 * and the one place that decides what is logged in which environment.
 *
 * Its own module, re-exported by the facade, so the logger can import it
 * without the rest of the facade. The logger is reached from
 * `Common/Storage` at boot, and test files mock the facade with factories
 * that name only the calls they assert on: through the index, every logger
 * line in those tests would hit an undefined `log`.
 */
export const log = {
  debug: write("debug"),
  info: write("info"),
  warn: write("warn"),
  error: write("error"),
};
